import React from 'react';
import { Box, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import Chip from 'components/Chip';
import theme from 'theme';

const useStyles = makeStyles((theme) => ({
  whiteBoxContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(7),
    alignItems: 'center',
    padding: theme.spacing(7),
    backgroundColor: theme.palette.shades['clr-white-900'],
    borderRadius: '4px',
    position: 'relative',
    width: '800px',
  },
  selectDocumentBox: {
    display: 'flex',
    gap: theme.spacing(5),
    width: '100%',
    padding: theme.spacing(0, 6),
    justifyContent: 'center',
  },
  selectDocument: {
    display: 'flex',
    width: '336px',
    height: '199px',
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.neutral['clr-300']}`,
    color: theme.palette.neutral['clr-600'],
    transition: 'box-shadow 0.3s ease',
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '0px 0px 8px 0px #D2D2D28C',
      border: `1px solid ${theme.palette.primary.main}`,
    },
    '&:hover $optionImage': {
      bottom: '0px',
      boxShadow: '0px 0px 8px 0px #D2D2D28C',
    },
  },
  optionImageBox: {
    position: 'absolute',
    maxHeight: '92px',
    overflowY: 'hidden',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '96px',
    display: 'flex',
    justifyContent: 'center',
  },
  optionImageWrapper: {
    minWidth: '116px',
    display: 'flex',
    justifyContent: 'center',
    position: 'relative',
  },
  optionImage: {
    position: 'relative',
    bottom: '-18px',
    transition: 'bottom 0.5s ease',
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: theme.spacing(1),
    padding: theme.spacing(1),
  },
}));

const ResumeOptions = [
  {
    _id: 'CREATE_NEW',
    label: 'Create a New Resume',
    img: 'https://assets.languify.in/images/jdAndResumeDoc.png',
    backgroundColor: '#F4F0FF',
    mostPreferred: true,
  },
  {
    _id: 'IMPORT_EXISTING',
    label: 'Import  an Existing Resume',
    img: 'https://assets.languify.in/images/resumeDoc.png',
    backgroundColor: '#F0FDFF',
  },
];

const SelectResumeOption = ({ onSelect }) => {
  const classes = useStyles();

  return (
    <Box className={classes.whiteBoxContainer}>
      <Typography variant='h5-medium' color='neutral.clr-900'>
        Create your Own Resume
      </Typography>
      <Box className={classes.selectDocumentBox}>
        {ResumeOptions.map((data, index) => (
          <Box
            key={index}
            className={classes.selectDocument}
            sx={{ backgroundColor: data.backgroundColor }}
            onClick={() => onSelect(data._id)}
          >
            <Box className={classes.optionImageWrapper}>
              <Box className={classes.optionImageBox}>
                <img
                  width={92}
                  height={112}
                  src={data.img}
                  alt={data.label}
                  className={classes.optionImage}
                />
              </Box>
            </Box>
            <Box className={classes.contentContainer}>
              {data.mostPreferred && (
                <Chip
                  content='Most preferred'
                  bgColor={theme.palette.tertiary['clr-500']}
                  color={theme.palette.shades['clr-white-900']}
                  typographyVariant='overline-bold'
                  sx={{
                    borderRadius: '4px',
                    padding: '4px',
                  }}
                />
              )}
              <Typography variant='body01-bold' color='neutral.clr-900'>
                {data.label}
              </Typography>
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SelectResumeOption;
